﻿import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  display: 'flex',
  gap: '0.5em',
  flexWrap: 'wrap'
}));

type CardHeaderButtonContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used in the HeaderContainer to hold action buttons
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardHeaderButtonContainer = ({ children, ...rest}: CardHeaderButtonContainerProps) => {
  return <Root item {...rest}>
    { children }
  </Root>
}

export { CardHeaderButtonContainer };
